import { BadgeV3, ColorOption } from '@cimplico/components';
import { WorkpaperRoleEnum } from '../../types/workpaper';
import { formatMixedCase } from '../../utilities/formatting';

type WorkpaperProcedureRoleBadgeProps = {
    role: WorkpaperRoleEnum;
};

function WorkpaperProcedureRoleBadge({ role }: WorkpaperProcedureRoleBadgeProps): JSX.Element {
    let colour = '';

    switch (role) {
        case WorkpaperRoleEnum.PREPARER:
            colour = 'violet';
            break;
        case WorkpaperRoleEnum.APPROVER:
            colour = 'green';
            break;
        default:
            colour = 'red';
            break;
    }

    return <BadgeV3 color={colour as ColorOption} label={formatMixedCase(role)} rounded size="small" />;
}

export default WorkpaperProcedureRoleBadge;
